import { computed, inject, Injectable, Signal } from '@angular/core';
import { ActivityHierarchiesStore } from './activity-hierarchies.store';
import { ActivityHierarchyResponse } from '../../api/data-definitions/models/api/activity-hierarchy-response';

@Injectable({ providedIn: 'root' })
export class ActivityHierarchiesFacadeService {
  private readonly _store = inject(ActivityHierarchiesStore);

  activityHierarchies = this._store.activityHierarchies;
  error = this._store.error;

  getDashBoardActivityHierarchy(): Signal<ActivityHierarchyResponse | undefined> {
    if (this._store.dashBoardActivityHierarchy() === undefined) {
      this._store.loadDashBoardActivityHierarchy();
    }
    return computed(() => this._store.dashBoardActivityHierarchy());
  }

  getActivityHierarchy(id: string): Signal<ActivityHierarchyResponse | undefined> {
    // Ensure the hierarchy is loaded if necessary
    if (!this._store.activityHierarchies()[id]?.groups?.length) {
      this._store.loadActivityHierarchy(id);
    }

    // Return the hierarchy only if it has groups
    return computed(() => {
      const hierarchy = this._store.activityHierarchies()[id];
      return hierarchy?.groups?.length ? hierarchy : undefined;
    });
  }

  getActivityHierarchyByName(name: string): Signal<ActivityHierarchyResponse | undefined> {
    // Retrieve hierarchies from the store
    const hierarchies = this._store.activityHierarchies();
    const hierarchy = Object.values(hierarchies).find(h => h.name === name);

    // If the hierarchy is not found or has no groups, load it
    if (!hierarchy || !hierarchy.groups?.length) {
      this._store.loadActivityHierarchyByName(name);
    }

    // Return the hierarchy only if it has groups
    return computed(() => {
      const updatedHierarchies = this._store.activityHierarchies();
      return Object.values(updatedHierarchies).find(h => h.name === name && h.groups?.length);
    });
  }

  listActivityHierarchies(): Signal<ActivityHierarchyResponse[]> {
    if (!this._store.listed()) {
      this._store.loadActivityHierarchies();
    }
    return computed(() => Object.values(this._store.activityHierarchies()));
  }
}
